export default "__VITE_ASSET__Bo7C9yst__"